/**
 * Comprime una foto del celular a JPEG con lado mayor ≤ maxDim, para que la
 * subida sea rápida con datos móviles y no choque el límite de 10MB de Storage.
 * Si el navegador no puede procesarla (formato raro), devuelve el archivo tal cual.
 */
export async function compressImage(file, { maxDim = 1600, quality = 0.82 } = {}) {
  try {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, maxDim / Math.max(bitmap.width, bitmap.height));
    const w = Math.max(1, Math.round(bitmap.width * scale));
    const h = Math.max(1, Math.round(bitmap.height * scale));
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    canvas.getContext("2d").drawImage(bitmap, 0, 0, w, h);
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", quality));
    return blob && blob.size < file.size ? blob : file;
  } catch (_) {
    return file;
  }
}
